import React from 'react';
import { localize } from 'core/localization';
import { TextElement, Wrapper } from './CloseCourse.styled';

const CloseCourse = () => (
  <Wrapper>
    <TextElement appearance="span">{localize('[close course message]')}</TextElement>
  </Wrapper>
);

export default CloseCourse;
